import { GroupingConferenceDivision } from "~pages/Standings/enums/groupingConferenceDivision";
import { GroupingStagePool } from "~pages/Standings/enums/groupingStagePool";
import type { StandingConfiguration } from "~types/standingConfiguration";

export const getStandingGroupings = (standingConfiguration?: StandingConfiguration) => {
  const grouping = {
    STAGE_POOL: {
      values: [GroupingStagePool.Overall],
      defaultValue: GroupingStagePool.Overall,
    },
    CONFERENCE_DIVISION: {
      values: [GroupingConferenceDivision.Overall],
      defaultValue: GroupingConferenceDivision.Overall,
    },
  };
  if (standingConfiguration) {
    const buildRules = standingConfiguration.buildRules;
    if (buildRules.buildConferences) {
      grouping.CONFERENCE_DIVISION.values.push(GroupingConferenceDivision.Conference);
      grouping.CONFERENCE_DIVISION.defaultValue = GroupingConferenceDivision.Conference;
    }

    if (buildRules.buildDivisions) {
      grouping.CONFERENCE_DIVISION.values.push(GroupingConferenceDivision.Division);
      grouping.CONFERENCE_DIVISION.defaultValue = GroupingConferenceDivision.Division;
    }

    const configGrouping = standingConfiguration.buildRules.grouping;
    if (configGrouping === GroupingStagePool.Stage || configGrouping === GroupingStagePool.StagePool) {
      grouping.STAGE_POOL.values.push(configGrouping);
      grouping.CONFERENCE_DIVISION.defaultValue = GroupingConferenceDivision.Overall;
      grouping.STAGE_POOL.defaultValue = configGrouping;
    }
  }
  return grouping;
};
